import { Link } from "react-router-dom";
import logo from "../assets/logoo.png";
import { business } from "../../config/business";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Industries", path: "/industries" },
    { name: "Locations", path: "/locations" },
    { name: "Resources", path: "/resources" },
    { name: "PEB Cost Calculator", path: "/peb-cost-calculator" },
    { name: "FAQ", path: "/faq" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const products = [
    { name: "Industrial Sheds", path: "/industrial-sheds" },
    { name: "Pre-Fab Buildings", path: "/pre-fab-structure-buildings" },
    { name: "Sheds Fabrication", path: "/structure-steel-fabrication" },
    { name: "Industrial Structures", path: "/IndustrialStructures" },
    { name: "FabricationServices", path: "/FabricationServices" },
    { name: "PEB Warehouse", path: "/services/peb-warehouse" },
    { name: "PEB Factory Buildings", path: "/services/peb-factory-buildings" },
    { name: "Quality", path: "/quality" },
    { name: "Brochure", path: "/brochure" },
  ];

  return (
    <footer className="bg-foreground text-background" role="contentinfo">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src={logo} 
              alt="Vasavi Structures"
              className="h-12 md:h-16 mb-4 bg-background p-2 rounded" 
              width="150"
              height="64"
            />
            <p className="text-background/80 mb-4 text-sm md:text-base">
              Engineering Strength. Delivering Trust. High-quality industrial sheds, steel fabrication, and prefabricated buildings in Hyderabad.
            </p>
            <div className="flex space-x-4">
             <a
  href={business.social.facebook}
  target="_blank"
  rel="noopener noreferrer"
  className="text-background/80 hover:text-secondary transition-colors"
  onClick={handleLinkClick}
  aria-label="Visit Vasavi Structures on Facebook"
>
  <svg 
    className="w-5 h-5 md:w-6 md:h-6" 
    fill="currentColor" 
    viewBox="0 0 24 24" 
    aria-hidden="true"
  >
    {/* Official Facebook "f" icon */}
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
</a>
              <a
                href={business.social.instagram}
                className="text-background/80 hover:text-secondary transition-colors"
                onClick={handleLinkClick}
                aria-label="Visit Vasavi Structures on Instagram"
              >
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href={business.social.linkedin}
                className="text-background/80 hover:text-secondary transition-colors"
                onClick={handleLinkClick}
                aria-label="Visit Vasavi Structures on LinkedIn"
              >
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="font-montserrat text-lg md:text-xl font-bold mb-4 text-secondary">Quick Links</h2>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-background/80 hover:text-secondary transition-colors text-sm md:text-base"
                    onClick={handleLinkClick}
                    aria-label={`Navigate to ${link.name}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h2 className="font-montserrat text-lg md:text-xl font-bold mb-4 text-secondary">Our Products</h2>
            <ul className="space-y-2">
              {products.map((product) => (
                <li key={product.path}>
                  <Link 
                    to={product.path} 
                    className="text-background/80 hover:text-secondary transition-colors text-sm md:text-base"
                    onClick={handleLinkClick}
                    aria-label={`View ${product.name}`}
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="font-montserrat text-lg md:text-xl font-bold mb-4 text-secondary">Contact Us</h2>
            <address className="space-y-3 not-italic">
              <p className="flex items-start gap-2 text-background/80 text-sm md:text-base">
                <svg className="w-4 h-4 md:w-5 md:h-5 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {business.address.line}
              </p>
              <p className="flex items-center gap-2 text-background/80 text-sm md:text-base">
                <svg className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href={business.phone.href} className="hover:text-secondary transition">{business.phone.display}</a>
              </p>
              <p className="flex items-center gap-2 text-background/80 text-sm md:text-base">
                <svg className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href={business.email.href} className="hover:text-secondary transition">{business.email.display}</a>
              </p>
            </address>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background/20">
        <div className="container-custom py-4 px-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-background/60 text-xs md:text-sm">
            <p>© 2026 Vasavi Structures. All rights reserved.</p>
            <p className="mt-2 md:mt-0 text-center md:text-left">Industrial Sheds | Fabrication | Prefab Buildings | Hyderabad</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;